import { DEFAULT_LOCATIONS, SANDBOX, PASSWORD } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 97d88ef2829197e7cb309c4f1fe7ee1f4e7081a1',
  staging: 'Token 97ef9f03bdeee1dc3eb93ebe30289527cdd1f647',
  prod: 'Token eb8f919f43625faff31e3541a4374268a0196727',
};

const token = selectToken(apiTokens);

const sandboxConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'sandbox',

  API_TOKEN: token,
  EMBOLD_CLIENT: SANDBOX,

  // login
  LOGIN_NETWORK_NAME: 'sandboxUserId',
  SHOW_REGION_SELECTOR: true,
  PASSWORD_REGEX: ['sandbox', 'i'],

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Nashville },

  // content
  DISPLAY_NAME: 'SANDBOX',
  FORM_VARIANT: PASSWORD,
  NO_WELCOME_LINK: false,
  DEFAULT_SEARCH_RADIUS: 10,
};

export default sandboxConfig;
